export default () => {
  const links = document.querySelectorAll('[data-delete-address]');

  if (links.length) {
    links.forEach((button) => {
      button.addEventListener('click', (e) => {
        const target = e.currentTarget.dataset.deleteAddress;
        e.preventDefault();

        if (
          // eslint-disable-next-line no-alert
          window.confirm('Are you sure you wish to delete this address?')
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' },
          });
        }
      });
    });
  }
};
